<template>

    <div class="section" :class="{ active: show }">
        <div class="section-header" @click.prevent="show = !show">
            <span v-if="name" class="section-title">{{ name }}</span>
            <i v-if="!show" class="fas fa-caret-down"></i>
            <i v-else class="fas fa-caret-up"></i>
       </div>
        <transition name="accordion" @before-enter="beforeEnter" @enter="enter" @before-leave="beforeLeave" @leave="leave">
            <div v-show="show" class="section-body">
                <div class="p-15">
                    <slot></slot>
                </div>
            </div>
        </transition>
    </div>

</template>

<style scoped lang="scss">

    .section {
        background: #fff;
        border-bottom: 1px solid $color-rule;
        &:last-child {
            margin-bottom: 30px;
        }
        .section-header:hover .section-title {
            color: $color-primary;
        }
        .section-header {
            align-items: center;
            background: #fff;
            cursor: pointer;
            display: flex;
            justify-content: space-between;
            padding: 10px 15px;
            position: relative;
            user-select: none;
            z-index: 1;
            i {
                color: $color-muted;
                font-size: 16px;
            }
        }
        .section-title {
            @include font-semibold(10px);
            color: $color-text;
            display: block;
            letter-spacing: 1px;
            text-transform: uppercase;
            transition: color .3s;
        }
        .section-body {
            border-top: 1px solid $color-rule;
            transition: all .15s;
            *:last-child {
                margin-bottom: 0;
            }
        }
    }

</style>

<script>

export default {

    props: {
        name: {
            type: String,
        },
        expanded: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            show: this.expanded,
        }
    },

    methods: {

        beforeEnter(el) {
            el.style.height = '0';
            el.style.overflow = 'hidden';
        },

        enter(el) {
            el.style.height = el.scrollHeight + 'px';
            el.style.overflow = 'none';
        },

        beforeLeave(el) {
            el.style.height = el.scrollHeight + 'px';
            el.style.overflow = 'hidden';
        },

        leave(el) {
            el.style.height = el.scrollHeight + 'px';
            el.style.height = '0';
        }

    },

}

</script>